/* @flow */
const prefix = str => `station/tags/${str}`;

export const SET_MODAL_OPTIONS = prefix('SET_MODAL_OPTIONS');

export const FETCH_ATTRIBUTES = prefix('FETCH_ATTRIBUTES');
export const FETCH_ATTRIBUTES_SUCCESS = prefix('FETCH_ATTRIBUTES_SUCCESS');
export const FETCH_ATTRIBUTES_FAILURE = prefix('FETCH_ATTRIBUTES_FAILURE');

export const FETCH_ENCLAVE_TAGS = prefix('FETCH_ENCLAVE_TAGS');
export const FETCH_ENCLAVE_TAGS_SUCCESS = prefix('FETCH_ENCLAVE_TAGS_SUCCESS');
export const FETCH_ENCLAVE_TAGS_FAILURE = prefix('FETCH_ENCLAVE_TAGS_FAILURE');

export const FETCH_INDICATOR_TAGS = prefix('FETCH_INDICATOR_TAGS');
export const FETCH_INDICATOR_TAGS_SUCCESS = prefix('FETCH_INDICATOR_TAGS_SUCCESS');
export const FETCH_INDICATOR_TAGS_FAILURE = prefix('FETCH_INDICATOR_TAGS_FAILURE');

export const ADD_INDICATOR_TAG = prefix('ADD_INDICATOR_TAG');
export const ADD_INDICATOR_TAG_SUCCESS = prefix('ADD_INDICATOR_TAG_SUCCESS');
export const ADD_INDICATOR_TAG_FAILURE = prefix('ADD_INDICATOR_TAG_FAILURE');
export const ADD_INDICATOR_TAGS_BULK = prefix('ADD_INDICATOR_TAGS_BULK');

export const REMOVE_INDICATOR_TAG = prefix('REMOVE_INDICATOR_TAG');
export const REMOVE_INDICATOR_TAG_SUCCESS = prefix('REMOVE_INDICATOR_TAG_SUCCESS');
export const REMOVE_INDICATOR_TAG_FAILURE = prefix('REMOVE_INDICATOR_TAG_FAILURE');



// WEBPACK FOOTER //
// ./src/app/modules/tags/action-types.js